"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Indent = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _core = require("@tiptap/core");

var _prosemirrorState = require("prosemirror-state");

var _excluded = ["indent"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Indent = _core.Extension.create({
  name: 'indent',
  addOptions: function addOptions() {
    return {
      types: ['listItem', 'paragraph', 'heading'],
      minLevel: 0,
      maxLevel: 8
    };
  },
  addGlobalAttributes: function addGlobalAttributes() {
    var _this = this;

    return [{
      types: this.options.types,
      attributes: {
        indent: {
          renderHTML: function renderHTML(attributes) {
            return (attributes === null || attributes === void 0 ? void 0 : attributes.indent) > _this.options.minLevel && (attributes === null || attributes === void 0 ? void 0 : attributes.indent) <= _this.options.maxLevel ? {
              style: "margin-left:".concat(attributes.indent, "em")
            } : null;
          },
          parseHTML: function parseHTML(element) {
            var style = element.getAttribute('style');

            if (style) {
              var level = Number(style.replace(/\D/g, ''));
              return level && level > _this.options.minLevel && level <= _this.options.maxLevel ? level : null;
            }

            return null;
          }
        }
      }
    }];
  },
  addCommands: function addCommands() {
    var _this2 = this;

    var setNodeIndentMarkup = function setNodeIndentMarkup(tr, pos, delta) {
      var _tr$doc;

      var node = tr === null || tr === void 0 ? void 0 : (_tr$doc = tr.doc) === null || _tr$doc === void 0 ? void 0 : _tr$doc.nodeAt(pos);

      if (node) {
        var nextLevel = (node.attrs.indent || 0) + delta;
        var _this2$options = _this2.options,
            minLevel = _this2$options.minLevel,
            maxLevel = _this2$options.maxLevel;
        var indent = nextLevel < minLevel ? minLevel : nextLevel > maxLevel ? maxLevel : nextLevel;

        if (indent !== node.attrs.indent) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          var _node$attrs = node.attrs,
              oldIndent = _node$attrs.indent,
              currentAttrs = (0, _objectWithoutProperties2.default)(_node$attrs, _excluded);
          var nodeAttrs = indent > minLevel ? _objectSpread(_objectSpread({}, currentAttrs), {}, {
            indent: indent
          }) : currentAttrs;
          return tr.setNodeMarkup(pos, node.type, nodeAttrs, node.marks);
        }
      }

      return tr;
    };

    var updateIndentLevel = function updateIndentLevel(tr, delta) {
      var _tr = tr,
          doc = _tr.doc,
          selection = _tr.selection;

      if (doc && selection && (selection instanceof _prosemirrorState.TextSelection || selection instanceof _prosemirrorState.AllSelection)) {
        var from = selection.from,
            to = selection.to;
        doc.nodesBetween(from, to, function (node, pos) {
          if (_this2.options.types.includes(node.type.name)) {
            tr = setNodeIndentMarkup(tr, pos, delta);
            return false;
          }

          return true;
        });
      }

      return tr;
    };

    var applyIndent = function applyIndent(direction) {
      return function () {
        return function (_ref) {
          var tr = _ref.tr,
              state = _ref.state,
              dispatch = _ref.dispatch;
          var selection = state.selection;
          tr = tr.setSelection(selection);
          tr = updateIndentLevel(tr, direction);

          if (tr.docChanged) {
            dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr);
            return true;
          }

          return false;
        };
      };
    };

    return {
      indent: applyIndent(1),
      outdent: applyIndent(-1)
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this3 = this;

    return {
      'Shift-Alt-i': function ShiftAltI() {
        return _this3.editor.commands.indent();
      },
      'Shift-Alt-o': function ShiftAltO() {
        return _this3.editor.commands.outdent();
      }
    };
  }
});

exports.Indent = Indent;